import LibBoolean from "./libBool";

function hasValueObj(obj) {
	// Verifica se é um array
	if (Array.isArray(obj)) return false;

	// Verifica se é um objeto e se possui alguma chave com valor verdadeiro
	return obj != null && typeof obj === "object" && Object.keys(obj).some((key) => obj[key]);
}

// Extrai o campo 'data' de uma resposta se for um objeto ou array
function extractData(response) {
	if (response && (typeof response === "object" || Array.isArray(response))) {
		return response.data;
	}
	return null;
}

// Verifica se um objeto está vazio
function isEmptyObj(obj) {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function isObj(obj) {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
}

// Faz uma cópia profunda de um objeto
function deepClone(obj) {
	return JSON.parse(JSON.stringify(obj));
}

// Mescla dois objetos
function mergeObjects(target, source) {
	return { ...target, ...source };
}

// Verifica se um objeto possui uma chave específica
function hasKey(obj, key) {
	return obj != null && hasOwnProperty.call(obj, key);
}

// Verifica se um item é um objeto
function isObject(item) {
	return item && typeof item === "object" && !Array.isArray(item);
}

// Verifica se um item é um array
function isArray(item) {
	return Array.isArray(item);
}

// Achata um array de arrays em um único array
function flattenArray(arr) {
	return arr.reduce(
		(flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? flattenArray(toFlatten) : toFlatten),
		[]
	);
}

// Verifica se é um array e se possui algum registro, trata undefined ou vazio
function isArrayWithRecords(arr) {
	return Array.isArray(arr) && arr != null && arr.length > 0;
}

const getReturnUpdated = (response) => {
	if (Array.isArray(response.data)) {
		return response.data[0];
	} else if (typeof response.data === "object") {
		return response.data;
	} else {
		throw new Error("Formato do retorno inválido.");
	}
};

// Cria um novo objeto com o formato com a chave e valor
const SlicedObject = async (obj) => {
	return Object.entries(obj).reduce((acc, [key, value]) => {
		if (key === "active") {
			acc[key] = LibBoolean.booleanToStr(value);
		} else if (value instanceof Date) {
			acc[key] = value.toLocaleString("pt-BR");
		} else {
			// Se o valor for um objeto com chave "value", usamos apenas o "value"
			acc[key] = value.value || value;
		}
		return acc;
	}, {});
};

export {
	// usando
	hasValueObj,

	// testes
	extractData,
	isEmptyObj,
	deepClone,
	mergeObjects,
	hasKey,
	isObject,
	isArray,
	flattenArray,
	getReturnUpdated,
	SlicedObject,
	isObj,
	isArrayWithRecords,
};
// const newData = {
// 	...data,
// 	dtIni: data.dtIni.toLocaleString("pt-BR"),
// 	dtFim: data.dtFim.toLocaleString("pt-BR"),
// };
